angular.module('WBGrid', []).
    directive('wbGrid2', ['$filter','$translate', '$rootScope', '$http', '$tooltip', '$timeout', 'messageBoxSvc', 'uiUtilsSvc', 'gridSortSvc',
        function ($filter, $translate, $rootScope, $http, $tooltip, $timeout, messageBoxSvc, uiUtilsSvc, gridSortSvc) {
        return {
            restrict: 'AE',
            replace: 'true',
            scope: {
                gridOptions: '=',
                filterOptions: '=',
                ngModel: '=',
                rowSelected: '&',
                selectionChanged: '&',
                filterApplied: '&',
                rowEdit: '&',
                rowDelete: '&',
                rowAdd: '&',
                rowAddDisabled: '=',
            },
            templateUrl: 'directives/wb-grid2-tmpl.html',
            link: function(scope, elem, attrs) {
                scope.rows = [];
                scope.filteredRows = [];
                scope.selectedPage = 1;
                scope.pages = [];
                scope.filters = {};
                scope.sorts = {};
                scope.pageSizes = [
                    { value: 5, text: "5" },
                    { value: 10, text: "10" },
                    { value: 20, text: "20" },
                    { value: 30, text: "30" },
                    { value: 40, text: "40" },
                    { value: 50, text: "50" }];
                scope.hideFooter = scope.gridOptions.hideFooter;
                scope.noCommandColumn = scope.gridOptions.noCommandColumn;
                scope.rowNumberColumn = scope.gridOptions.rowNumberColumn;
                scope.disableRowSelection = scope.gridOptions.disableRowSelection;
                scope.multiSelect = scope.gridOptions.multiSelect;
                scope.grouping = scope.gridOptions.grouping || { enabled: false }
                scope.pageSize = scope.hideFooter ? 999999 : (scope.gridOptions.pageSize ? scope.gridOptions.pageSize : 30);
                scope.allSelected = { selected: false };
                scope.disabledField = scope.gridOptions.disabledField;
                scope.selectedField = scope.gridOptions.selectedField || 'isSelected';
                scope.highlightedField = scope.gridOptions.highlightedField;
                scope.dangerField = scope.gridOptions.dangerField;
                scope.dangerFn = scope.gridOptions.dangerFn;
                scope.disabledAreSelectable = scope.gridOptions.disabledAreSelectable;
                scope.scrollbarWidth = uiUtilsSvc.getScrollbarWidth();
                scope.disableDeleteConfirmation = scope.gridOptions.disableDeleteConfirmation || false;

                var rndId = 'wb-table-content-parent-' + (new Date()).getTime() + '-' + Math.floor((Math.random() * 100000000) + 1);
                $(elem).find('.wb-table-content-parent').attr('id', rndId);

                var dropdown = null;

                function setIsAllSelected() {
                  //  $timeout(function () {
                        for (var r = 0; r < scope.filteredRows.length; r++) {
                            var m = scope.filteredRows[r];
                            if (scope.disabledField && m[scope.disabledField] && !scope.disabledAreSelectable) {
                                continue;
                            }
                            if (!m[scope.selectedField]) {
                                scope.allSelected.selected = false;
                                return;
                            }
                        }

                        if (scope.filteredRows.length > 0) {
                            scope.allSelected.selected = true;
                        }
                    //});
                }

                var busyTooltip = $tooltip(elem, { title: '<h4><i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;' + $translate.instant('TXT_LOADING_DATA') + ' ...</h4>', trigger: 'manual', placement: 'top center', html: true });

                scope.toggleGroupRowExpand = function (row) {
                    row.__expanded__ = !row.__expanded__;
                }

                scope.$watch('ngModel', function (newValue) {
                    if (newValue && newValue.$promise && !newValue.$promise.$resolved) {

                        busyTooltip.$promise.then(busyTooltip.show);

                        function hideToolTip() {
                            busyTooltip.$promise.then(busyTooltip.hide);
                        }

                        newValue.$promise.then(hideToolTip, hideToolTip);
                    }
                });

                scope.onSelectAllClick = function () {
                    var m = null;
                    var s = false;
                    var sc = false;
                    if (scope.allSelected.selected) {
                        for (var r = 0; r < scope.filteredRows.length; r++) {
                            m = scope.filteredRows[r];
                            if (scope.disabledField && m[scope.disabledField] && !scope.disabledAreSelectable) {
                                continue;
                            }
                            if (!m[scope.selectedField]) {
                                m[scope.selectedField] = true;
                                s = true;
                                sc = true;
                            }
                        }
                    } else {
                        for (var r = 0; r < scope.filteredRows.length; r++) {
                            m = scope.filteredRows[r];
                            if (scope.disabledField && m[scope.disabledField] && !scope.disabledAreSelectable) {
                                continue;
                            }
                            if (m[scope.selectedField]) {
                                m[scope.selectedField] = false;
                                sc = true;
                            }
                        }
                    }

                    if (s && scope.rowSelected()) {
                        scope.rowSelected()(getSelectedRow());
                    }
                    if (sc && scope.selectionChanged()) {
                        scope.selectionChanged()();
                    }
                }

                function getSelectedRow() {
                    var selection = [];

                    for (var r = 0; r < scope.ngModel.length; r++) {
                        var m = scope.ngModel[r];
                        if (m[scope.selectedField]) {
                            selection.push(m);
                            if (!scope.multiSelect) {
                                break;
                            }
                        }
                    }

                    return scope.multiSelect
                        ? selection
                        : selection.length > 0 ? selection[0] : null;
                }
                
                function prepareCommandMenu() {
                    var commandMenu = [];

                    var selectedRow = getSelectedRow();

                    if (scope.rowAdd && scope.rowAdd() && !scope.rowAddDisabled) {
                        commandMenu.push({
                            "text": $translate.instant('TXT_MENU_NEW'),
                            "click": "onDropdownNewClick()"
                        });
                    }

                    if (scope.rowEdit && scope.rowEdit()) {
                        if (selectedRow &&
                            (scope.gridOptions.hideEdit && !scope.gridOptions.hideEdit(selectedRow)) ||
                            !(scope.gridOptions.hideEdit)) {
                            commandMenu.push({
                                "text": $translate.instant('TXT_MENU_EDIT'),
                                "click": "onDropdownEditClick()"
                            });
                        }
                    }

                    if (scope.gridOptions.customCmds && scope.gridOptions.customCmds.length > 0) {
                        var first = true;
                        for (var c = 0; c < scope.gridOptions.customCmds.length; c++) {
                            var command = scope.gridOptions.customCmds[c];
                            if ((command.hide && selectedRow && !command.hide(selectedRow)) || !command.hide) {
                                if (first) {
                                    first = false;
                                    if (commandMenu.length > 0) {
                                        commandMenu.push({ "divider": true });
                                    }
                                }
                                commandMenu.push({
                                    "text": $translate.instant(command.text),
                                    "click": "onDropdownCustomCommandClick(" + c + ")"
                                });
                            }
                        }
                    }

                    if (scope.rowDelete && scope.rowDelete()) {
                        if (selectedRow &&
                            (scope.gridOptions.hideDelete && !scope.gridOptions.hideDelete(selectedRow)) ||
                            !(scope.gridOptions.hideDelete)) {
                            if (commandMenu.length > 0 && !commandMenu[commandMenu.length - 1].divider) {
                                commandMenu.push({ "divider": true });
                            }

                            commandMenu.push(
                                {
                                    "text": $translate.instant('TXT_MENU_DELETE'),
                                    "click": "onDropdownDeleteClick()"
                                });
                        }
                    }
                    return commandMenu;
                }

                scope.commandDropdown = [];
                scope.onDropdownNewClick = function () {
                    var selectedRow = getSelectedRow();
                    if (scope.rowAdd && scope.rowAdd() && !scope.rowAddDisabled) {
                        scope.rowAdd()(getSelectedRow());
                    }
                }
                scope.onDropdownCustomCommandClick = function (idx) {
                    var command = scope.gridOptions.customCmds[idx];
                    if (command && command.command) {
                        command.command(getSelectedRow(), scope.filteredRows);
                    }
                }

                scope.onDropdownEditClick = function () {
                    var selectedRow = getSelectedRow();
                    if (scope.rowEdit && scope.rowEdit() && selectedRow &&
                        ((scope.gridOptions.hideEdit && !scope.gridOptions.hideEdit(selectedRow)) || !(scope.gridOptions.hideEdit))) {
                        scope.rowEdit()(selectedRow);
                    }
                }

                scope.onDropdownDeleteClick = function () {
                    var selectedRow = getSelectedRow();
                    if (scope.rowDelete && scope.rowDelete() && selectedRow) {

                        if (scope.disableDeleteConfirmation) {
                            scope.rowDelete()(selectedRow);
                        } else {
                            messageBoxSvc.showMessageDlg({
                                title: 'TXT_TITLE_CONFIRM_DELETE',
                                message: 'TXT_TEXT_CONFIRM_DELETE',
                                buttons: [{
                                    text: 'TXT_BTN_NO'
                                }, {
                                    text: 'TXT_BTN_YES',
                                    callback: function () { scope.rowDelete()(selectedRow); }
                                }]
                            });
                        }
                    }
                }

                scope.showCommandMenu = function (e) {
                    scope.commandDropdown = prepareCommandMenu();
                    return false;
                }

                scope.onRowDblClick = function (row) {
                    var selectedRow = getSelectedRow();
                    if (scope.rowEdit && scope.rowEdit() && selectedRow &&
                        ((scope.gridOptions.hideEdit && !scope.gridOptions.hideEdit(selectedRow)) || !(scope.gridOptions.hideEdit))) {
                        scope.rowEdit()(selectedRow);
                    }
                }

                scope.onAddMenuClick = function () {
                    var selectedRow = getSelectedRow();
                    if (scope.rowAdd && scope.rowAdd() && !scope.rowAddDisabled) {
                        scope.rowAdd()(getSelectedRow());
                    }
                }

                scope.onPageSizeChange = function(pageSize) {
                    if (pageSize && pageSize > 0) {
                        scope.recalculatePages();
                        scope.selectPage(scope.selectedPage);
                    }
                }

                scope.recalculatePages = function() {
                    scope.pages.length = 0;
                    var pages = scope.filteredRows.length / scope.pageSize;
                    for (var p = 0; p <  pages; p++) {
                        scope.pages.push(p);
                    }
                }

                scope.onHeaderClick = function (col) {

                    if (!scope.gridOptions.sortInfo) {
                        return;
                    }

                    for (var c = 0; c < scope.gridOptions.columnDefs.length; c++) {
                        var column = scope.gridOptions.columnDefs[c];
                        if (column !== col) {
                            column.sortDirection = null;
                        }
                    }

                    if (col.sortDirection === 'dsc') {
                        col.sortDirection = 'asc';
                    } else {
                        col.sortDirection = 'dsc';
                    }

                    scope.applyFilters();
                    scope.selectPage(scope.selectedPage);
                }

                function getSortByProperty(options) {
                    for (var c = 0; c < options.columnDefs.length; c++) {
                        var column = options.columnDefs[c];
                        if (column.sortDirection && (column.sortDirection === 'asc' || column.sortDirection === 'dsc')) {
                            return {
                                field: column.field,
                                direction: column.sortDirection
                            };
                        }
                    }

                    if (options.sortInfo) {
                        var field = options.sortInfo.fields[0];
                        var direction = options.sortInfo.directions[0];

                        for (var c = 0; c < options.columnDefs.length; c++) {
                            var column = options.columnDefs[c];
                            if (column.field === field) {
                                column.sortDirection = direction;
                                return {
                                    field: field,
                                    direction: direction
                                }
                            }
                        }
                    }

                    return null;
                }

                function getCellFilters(columnDefs) {
                    var cellFilters = {};
                    for (var i = 0; i < columnDefs.length; i++) {
                        var row = columnDefs[i];
                        if (row.cellFilter) {
                            cellFilters[row.field] = parseFilter(row.cellFilter);
                        }
                    }

                    return cellFilters;
                }

                function getCellSorts(columnDefs) {
                    var cellSorts = {};
                    for (var i = 0; i < columnDefs.length; i++) {
                        var row = columnDefs[i];
                        if (row.sort) {
                            cellSorts[row.field] = gridSortSvc[row.sort];
                        }
                    }

                    return cellSorts;
                }

                scope.applyFilters = function() {
                    scope.filteredRows.length = 0;


                    var cellFilters = getCellFilters(scope.gridOptions.columnDefs);

                    function comparator(value, text) {
                        text = (''+text).toLowerCase();
                        return (''+value).toLowerCase().indexOf(text) > -1;
                    }

                    function filterImp(row) {
                        var result = true;
                        var value;

                        var globalFilter = scope.filterOptions && scope.filterOptions.filterText ? scope.filterOptions.filterText : null;
                        var globalFilterFunction = scope.filterOptions && scope.filterOptions.filterFunction ? scope.filterOptions.filterFunction : null;
                        if (globalFilter || globalFilterFunction) {
                            var r = [{}];
                            for (var c = 0; c < scope.gridOptions.columnDefs.length; c++) {
                                var field = scope.gridOptions.columnDefs[c].field;
                                
                                if (cellFilters[field] && cellFilters[field].filterName === "wbCurrencyFlt") {
                                    // For these do not apply filter prior searching
                                    r[0][field] = row[field];
                                } else if (cellFilters[field] && cellFilters[field].filterName === "checkmark") {
                                   // do not search for bit values globaly
                                   // r[0][field] = !!row[field] ? 1 : 0;
                                } else {
                                    value = cellFilters[field] ? $filter(cellFilters[field].filterName)(row[field], cellFilters[field].params) : row[field];
                                    r[0][field] = value;
                                }
                            }
                            if (globalFilter && $filter('filter')(r, globalFilter).length === 0) {
                                return false;
                            }
                            if (globalFilterFunction && $filter('filter')(r, globalFilterFunction).length === 0) {
                                return false;
                            }
                        }

                        for(var field in scope.filters) {

                            var text = scope.filters[field];
                            if (text) {
                                if (cellFilters[field] && cellFilters[field].filterName === "wbCurrencyFlt") {
                                    // For these do not apply filter prior searching
                                    value = row[field];
                                } else if (cellFilters[field] && cellFilters[field].filterName === "checkmark") {
                                    value = !!row[field] ? 1 : 0
                                } else {
                                    value = cellFilters[field] ? $filter(cellFilters[field].filterName)(row[field], cellFilters[field].params) : row[field];
                                }
                                var comp = comparator(value, text);
                                result &= comp;
                            }
                        }
                        return result;
                    }

                    var filteredRows = $filter('filter')(scope.ngModel, filterImp);
                    var sortBy = getSortByProperty(scope.gridOptions);

                    var cellSorts = getCellSorts(scope.gridOptions.columnDefs);

                    var sortedRows = !!sortBy ? $filter('orderBy')(filteredRows, function (row) {

                        var sort = cellSorts[sortBy.field];
                        if (sort) {
                            return sort(row[sortBy.field])
                        }

                        var filter = cellFilters[sortBy.field];

                        if (filter && filter.filterName && filter.filterName.substring(0, "date:".length) === "date") {
                            return gridSortSvc.date(row[sortBy.field]);
                        } else {
                            // TODO: Shouldn't we sort based on filtered values
                            return row[sortBy.field];
                        }
                    }, sortBy.direction === 'dsc') : filteredRows;

                    scope.filteredRows.push.apply(scope.filteredRows, sortedRows);

                    if (scope.filterApplied && scope.filterApplied()) {
                        scope.filterApplied()(scope.filteredRows);
                    }
                }

                scope.$watch('filterOptions', function () {

                    scope.selectedPage = 1; // reset paging
                    scope.applyFilters();
                    scope.recalculatePages();
                    scope.selectPage(scope.selectedPage);
                }, true);

                scope.$watch('filters', function () {
                    scope.selectedPage = 1; // reset paging
                    scope.applyFilters();
                    scope.recalculatePages();
                    scope.selectPage(scope.selectedPage);
                }, true);

                scope.$watchCollection('ngModel', function (newValue, oldValue) {
                    scope.applyFilters();
                    scope.recalculatePages();
                    scope.selectPage(scope.selectedPage);
                    setIsAllSelected();
                });

                scope.selectPage = function(pageNo) {
                    var nPageNo = Math.max(0, Math.min(scope.pages.length - 1, pageNo - 1));
                    scope.rows = scope.filteredRows.slice(nPageNo * scope.pageSize, (nPageNo  + 1) * scope.pageSize);
                    scope.selectedPage = nPageNo + 1;
                }


                scope.onPageSizeChange = function(pageSize) {
                    scope.recalculatePages();
                    scope.selectPage(scope.selectedPage);
                }

                scope.onRowClicked = function (row) {

                    if (scope.disableRowSelection) {

                        if (scope.grouping.enabled && row[scope.grouping.isGroupRowPropertyName]) {
                            scope.toggleGroupRowExpand(row);
                        }

                        return;
                    }

                    var oldVal = row[scope.selectedField];

                    // Do nothing if row is disabled
                    if (scope.disabledField && row[scope.disabledField] && !scope.disabledAreSelectable) {
                        return;
                    }

                    if (scope.multiSelect) {
                        row[scope.selectedField] = !row[scope.selectedField]
                    } else {
                        for (var r = 0; r < scope.ngModel.length; r++) {
                            var m = scope.ngModel[r];
                            if (m !== row && m[scope.selectedField]) {
                                m[scope.selectedField] = false;
                            }
                        }
                        row[scope.selectedField] = true;
                    }

                    setIsAllSelected();

                    if (scope.rowSelected() && row[scope.selectedField]) {
                        scope.rowSelected()(row);
                    }

                    if (oldVal != row[scope.selectedField]) {
                        if (scope.selectionChanged()) {
                            scope.selectionChanged()();
                        }
                    }
                }

                scope.rowSelectionClicked = function (row) {
                    // Do nothing if row is disabled
                    if (scope.disabledField && row[scope.disabledField] && !scope.disabledAreSelectable) {
                        return;
                    }

                    setIsAllSelected();

                    if (scope.rowSelected() && row[scope.selectedField]) {
                        scope.rowSelected()(row);
                    }

                    if (scope.selectionChanged()) {
                        scope.selectionChanged()();
                    }
                }

                scope.exportDropdown = [{
                    "text": $translate.instant('TXT_EXPORT_CSV'),
                    "click": "onCSVExportClick()"
                }, {
                    "text": $translate.instant('TXT_EXPORT_XLS'),
                    "click": "onXLSExportClick()"
                }];

                scope.onCSVExportClick = function () {
                    genericDataExport('Csv');
                }

                scope.onXLSExportClick = function () {
                    genericDataExport('Xls');
                }

                function prepareData() {

                    function shouldApplyFilter(cellFilter) {
                        if (!cellFilter) {
                            return false;
                        }

                        if (cellFilter === "wbCurrencyFlt" ||
                            cellFilter === "checkmark") {
                            return false;
                        }

                        return true;
                    }

                    var keys = [];
                    var columns = [];
                    for (var f in scope.gridOptions.columnDefs) {
                        var colDef = scope.gridOptions.columnDefs[f];
                        if (colDef.field && !colDef.noExport) {
                            keys.push({
                                field: colDef.field,
                                filter: colDef.cellFilter,
                            });
                            columns.push({
                                field: colDef.field,
                                filter: colDef.cellFilter,
                                caption: $translate.instant(colDef.displayName),
                                bitmaskValues: colDef.exportBitMaskValues,
                                width: colDef.width
                            });
                        }
                    }

                    var filteredRows = scope.filteredRows;
                    var data = [];
                    for (var idx = 0; idx < filteredRows.length; idx++) {
                        var entity = filteredRows[idx];
                        var e = [];
                        for (var f in keys) {
                            var key = keys[f];
                            if (shouldApplyFilter(key.filter)) {
                                var flt = parseFilter(key.filter);
                                var params = [entity[key.field]];
                                if (flt.params) {
                                    params.push.apply(params, flt.params);
                                }
                                var filter = $filter(flt.filterName);
                                e.push(filter.apply(filter, params));
                            } else {
                                e.push(entity[key.field]);
                            }
                        }
                        data.push(e);
                    }

                    return { columns: columns, rows: data };
                }

                function genericDataExport(format) {
                    $("#dataDownloadIFrame").remove();

                    var data = prepareData();

                    $http({
                        method: 'POST',
                        url: '/Api/Export/' + format,
                        data: JSON.stringify(data)
                    })
                    .success(function (data, status, headers, config) {
                        $("#dataDownloadIFrame").remove();
                        $("body").append("<iframe id='dataDownloadIFrame' src='/Api/Export/Download?fileName=" + data.fileName + "' style='height: 0px;' ></iframe>");
                    });
                }

                function parseFilter(filterStr) {
                    var idx = filterStr.indexOf(':');
                    var res = {
                        filterName: idx !== -1 ? filterStr.substring(0, idx) : filterStr,
                        params: idx !== -1 ? unQuoteParams([filterStr.substring(idx + 1)]) : ''
                    };
                    return res;
                }

                function unQuoteParams(params) {
                    var ret = [];
                    for (var idx = 0; idx < params.length; idx++) {
                        var param = params[idx];
                        ret.push(param.replace(/^'(.+(?='$))'$/, '$1'));
                    }

                    return ret;
                }

                scope.getFilteredValue = function(value, filter) {
                    if (filter) {
                        var flt = parseFilter(filter);
                        return $filter(flt.filterName)(value, flt.params);
                    } else {
                        return value;
                    }
                }

                scope.selectedRangeHi = function() {
                    return Math.min(scope.selectedPage * scope.pageSize, scope.filteredRows.length);
                }
            }
        };
        }])


.animation('.wb-group-row', [function () {
    return {
        removeClass: function (element, doneFn) {
            jQuery(element).find('div.wb-table-group-content').css("margin-top", "0px");
        },
        addClass: function (element, doneFn) {

            var el = jQuery(element).find('div.wb-table-group-content');

            el.css("margin-top", "-" + el.height() + "px");
            setTimeout(function() {
                jQuery(element).removeClass('ng-hide-animate');
            }, 200)
        }
    }
}]);